import { render, staticRenderFns } from "./TradingConditions.vue?vue&type=template&id=fd413cde&scoped=true"
import script from "./TradingConditions.vue?vue&type=script&lang=js"
export * from "./TradingConditions.vue?vue&type=script&lang=js"
import style0 from "./TradingConditions.vue?vue&type=style&index=0&id=fd413cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd413cde",
  null
  
)

export default component.exports